class BlogLoadMore {
  constructor() {
    this.button = document.getElementById('load-more-blogs');
    if (!this.button) return;

    this.total = parseInt(this.button.dataset.total);
    this.perPage = parseInt(this.button.dataset.perPage);
    this.current = parseInt(this.button.dataset.current);
    this.hiddenArticles = document.querySelectorAll('.blog-article.hidden');
    this.viewingCount = document.getElementById('viewing-count');

    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.loadMore());
    this.updateButtonVisibility();
    this.updateViewingCount();
  }

  loadMore() {
    // Call the showLoader function
    showLoader();

    setTimeout(() => {
      const nextBatch = Array.from(this.hiddenArticles).slice(0, this.perPage);

      nextBatch.forEach(article => {
        article.classList.remove('hidden');
      });
      this.hiddenArticles = document.querySelectorAll('.blog-article.hidden');
      this.current = document.querySelectorAll('.blog-article:not(.hidden)').length;
      this.button.dataset.current = this.current;
      if (this.viewingCount) {
        this.viewingCount.dataset.current = this.current;
        this.updateViewingCount();
      }
      this.updateButtonVisibility();
      hideLoader();
    }, 500); 
  }

  updateViewingCount() {
    if (!this.viewingCount) return;

    const template = this.viewingCount.dataset.template;
    if (!template) return;

    // If all articles are loaded, show total count for both current and total
    const isAllLoaded = this.current >= this.total;
    const currentCount = isAllLoaded ? this.total : this.current;

    const text = template
      .replace('{{ current }}', currentCount)
      .replace('{{ total }}', this.total);

    this.viewingCount.textContent = text;
  }

  updateButtonVisibility() {
    if (this.total == this.current) {
      this.button.style.display = 'none';
      // When no articles remain, update count to show total
      this.current = this.total;
      this.updateViewingCount();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BlogLoadMore();
});